export default __webpack_public_path__ + "media/images/front/about/line-da434e57f77bf9e1e2bf5445fd82dbf6.png";